import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAdminStore } from '../../store/adminStore';
import useAdminPageMeta from '../../hooks/useAdminPageMeta';
import Brand from '../../components/Brand';
import { Mail, Lock, ArrowRight } from 'lucide-react';

export default function AdminLoginPage() {
  useAdminPageMeta('Sign in');
  const { login, loading } = useAdminStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState(null);
  const nav = useNavigate(); const loc = useLocation();
  const from = loc.state?.from?.pathname || '/admin/dashboard';

  const submit = async (e) => {
    e.preventDefault(); setErr(null);
    try { await login(email, password); nav(from, { replace: true }); }
    catch (e) { setErr(e.message); }
  };

  return (
    <div className="min-h-screen bg-ee-bg flex flex-col">
      <div className="p-6"><Brand subtitle="The EE Control Center" /></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="hero-title text-4xl text-white mb-2">Control Center</h1>
            <p className="text-ee-muted">Author access only</p>
          </div>
          <form onSubmit={submit} className="ee-card p-8 space-y-4">
            <label className="block">
              <span className="text-xs uppercase tracking-wider text-gold/80">Email</span>
              <div className="mt-1 flex items-center gap-2 bg-ee-bg border border-ee-border rounded-md px-3 focus-within:border-gold">
                <Mail size={16} className="text-ee-muted" />
                <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="flex-1 bg-transparent py-3 outline-none text-white text-sm" />
              </div>
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-wider text-gold/80">Password</span>
              <div className="mt-1 flex items-center gap-2 bg-ee-bg border border-ee-border rounded-md px-3 focus-within:border-gold">
                <Lock size={16} className="text-ee-muted" />
                <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="flex-1 bg-transparent py-3 outline-none text-white text-sm" />
              </div>
            </label>
            {err && <div className="text-sm text-red-400 bg-red-400/10 border border-red-400/30 rounded-md p-2">{err}</div>}
            <button data-testid="admin-submit" type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 py-3 rounded-md gold-grad text-black font-semibold disabled:opacity-50">
              {loading ? 'Signing in…' : <>Enter Control Center <ArrowRight size={16} /></>}
            </button>
            <div className="text-center text-xs text-ee-dim">Not an admin? <Link to="/login" className="text-gold hover:underline">Reader login</Link></div>
          </form>
        </div>
      </div>
    </div>
  );
}
